// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__a__i2","title":"styles_title__2Y2tl","subtitle":"styles_subtitle__Hd4bR","text":"styles_text__u1VzR"};